const baseEndpoint = "https://book.txj.co.jp/v4";

const serviceEndpoint = `${baseEndpoint}/Services`;
const pageEndpoint = `${baseEndpoint}/Pages`;

const endpoints = {
  search: `${serviceEndpoint}/EntityService.jsws/Search`,
  injection: `${serviceEndpoint}/Injection.aspx`,
  searchPage: `${pageEndpoint}/Search.aspx`,
  bookingQuote: `${serviceEndpoint}/BookingService.jsws/GetBookingQuote`,
  campaign: `${serviceEndpoint}/CampaignService.jsws/GetAdCampaign`,
};

const OREndpoint = "https://be.kagamino.tours/api/checkout";

export { endpoints, OREndpoint };
